module.exports = __webpack_public_path__ + "img/user.819d0cdc.png";